import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Icon from 'react-fa'

const HelpLink = props => (
  <a className={props.className || ''} target='_blank' rel='noopener noreferrer' href={`${props.baseHelpUrl}#${props.helpTopic}`}>
    {props.children}
  </a>
)

HelpLink.propTypes = {
  baseHelpUrl: PropTypes.string.isRequired,
  helpTopic: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
}


export default HelpLink



// WEBPACK FOOTER //
// ./src/components/HelpLink/HelpLink.js